const PageInfluencerModel = {
    type: 'page',
    name: 'influencer',
    blocks: [
        {
            name: 'intro',
            max: 1,
            type: 'html',
            label: 'Introduction',
        },
        {
            name: 'success',
            max: 1,
            type: 'html',
            label: 'After submit',
        },
    ],
};

export default PageInfluencerModel;
